import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { SaveToastService } from './save-toast.service';

@Injectable()
export class ErrorService {

  constructor(
    private saveToast: SaveToastService,
  ) { }

  /**
   * Handles an error.
   *
   * @param error The error object to handle.
   * @param notifyUser Whether to display a toast to the user. The toast always
   *   shows a fixed "Erreur enregistrement" message (not the raw error).
   * @param _prettyMessage Kept for backward compatibility; no longer displayed.
   */
  public handleError(error: any, notifyUser: boolean, _prettyMessage?: string): void {
    if (error) {
      if (notifyUser) {
        this.saveToast.showError();
      }
      console.error(error);
      Sentry.captureException(error);
    }
  }

  /**
   * Show the fixed error toast.
   */
  public handleLogicError(_error?: string, _title?: string): void {
    this.saveToast.showError();
  }
}
